<template>
  <section
    v-if="!cookiesAccepted"
    :class="$style.banner"
  >
    <ParagraphBody
      bodySize="small"
      :class="$style.cookieMessage"
    >
      {{ instructions }}
    </ParagraphBody>
    <div :class="$style.buttons">
      <Button
        :class="$style.button"
        data-test-id="CookieBanner__AcceptButton"
        isMarketingStyle
        text="I Accept"
        @click="acceptCookies"
      />
      <Button
        :class="$style.button"
        href="https://jumpcloud.com/about-our-use-cookies/"
        isMarketingStyle
        text="Read More"
      />
    </div>
  </section>
</template>

<script>
import { Button, ParagraphBody } from '@jumpcloud/ui-components';
import { mapActions, mapState } from 'vuex';

export default {
  name: 'CookieBanner',
  components: {
    Button,
    ParagraphBody,
  },
  data() {
    return {
      instructions: 'JumpCloud uses cookies on this website to ensure you have an excellent user experience. By continuing to use this website, you accept the use of cookies. For more information about the cookies used, click Read More.',
    };
  },
  computed: {
    ...mapState(['cookiesAccepted']),
  },
  created() {
    this.checkCookiesAccepted();
  },
  methods: {
    ...mapActions(['checkCookiesAccepted', 'updateCookiesAccepted']),
    acceptCookies() {
      this.updateCookiesAccepted(true);
    },
  },
};
</script>

<style module>
  .banner {
    background-color: rgba(247, 247, 251, 0.9);
    bottom: 0;
    left: 0;
    min-height: 8rem;
    padding: 1rem 2rem;
    position: fixed;
    text-align: center;
    width: 100%;
    z-index: 10;
  }

  .buttons {
    margin-top: 1.5rem;
  }

  .button {
    width: auto;
  }

  .button:first-of-type {
    margin-right: 1rem;
  }
</style>
